<template>
    <div class="timebrush">
        <svg :viewBox="`0,0,${svgWidth},${svgHeight}`" ref="svg">
            <g id="mainG" ref="mainG" :transform="`translate(${margin.left}, ${margin.top})`">
                <g fill-opacity="0.2"> 
                    <!-- <circle v-for='(p, index) in points' :key='index' :data-test="scale.y()" :class="p.properties.completed ? 'success' : 'fail'" :transform="`translate(${scale.p.properties.date},${scale.y()})`" r="3"></circle> -->
                
                </g>  
            </g> 
        </svg>
    </div>
</template>

<script>
import * as d3 from 'd3';
import time_locale  from '../../d3_locale_uk-UA.json'
import moment from 'moment';

d3.timeFormatDefaultLocale(time_locale);

var formatMonth = d3.timeFormat("%b"),
    formatYear = d3.timeFormat("%Y");

function multiFormat(date) {
  return (d3.timeYear(date) < date ? formatMonth : formatYear) (date);
}

let date_format = multiFormat
let day_date_format = d3.timeFormat("%d");

export default {
    name: "time-brush",
    props: ['points'],

    data() {
        return {
            svgWidth: null,
            svgHeight: null,
            // width: null,
            // height: 120
        }
    },

    created() {
      this.margin = { left: 15, top: 40, right: 15, bottom: 0 };
    },

    mounted() {
        let self = this;    

        this.svgWidth = this.$el.clientWidth;
        this.svgHeight = 100;

        this.draw()
    },

    methods: {
        draw() {

            let self = this;
            // this.svg = d3.select(this.$refs.svg)
            this.mainG = d3.select(this.$refs.mainG)
            // .attr("viewBox", [0, 0, this.width, this.height]);

            const brush = d3.brushX()
                .extent([[0, 0], [this.width, this.height-1]])
                .on("start brush end", brushed);
            

            this.xAxis = g => g
                // .attr("transform", `translate(0,${this.height})`)
                .call(d3.axisTop(this.scale.x).tickFormat(date_format))

            // this.arc = d3.arc()
            //     .innerRadius(0)
            //     .outerRadius((this.height - this.margin.top - this.margin.bottom) / 2)
            //     .startAngle(0)
            //     .endAngle((d, i) => i ? Math.PI : -Math.PI)
            
            this.brushResizePath = function(d) {
                var e = +(d.type == "e"),
                    x = e ? 1 : -1,
                    y = self.height / 2;
                return "M" + (.5 * x) + "," + y + "A8,8 0 0 " + e + " " + (8.5 * x) + "," + (y + 8) + "V" + (2 * y - 8) + "A8,8 0 0 " + e + " " + (.5 * x) + "," + (2 * y) + "Z" + "M" + (3.5 * x) + "," + (y + 8) + "V" + (2 * y - 8) + "M" + (5.5 * x) + "," + (y + 8) + "V" + (2 * y - 8) +
                       "M" + (.5 * x) + "," + 0 + "V" + (self.height / 4 + self.height + 30); // палички
                
                // M -0.5 50 A 8 8 0 0 0 -10 58 V 92 A 8 8 0 0 0 -0.5 100 Z M -4 58 V 92 M -7 58 V 92
            }

            this.circle = this.mainG
                .selectAll("circle")
                .data(this.points)
                .join("circle")
                .attr("class", d => d.properties.completed ? "success" : "fail")
                .attr("transform", d => `translate(${this.scale.x(d.properties.date)},${this.scale.y()})`)
                .attr("r", 2);

            this.mainG.append("g")
                .call(this.xAxis);

            this.extent_captions = this.mainG
                .append("g")
                .attr("transform", "translate(0, -20)")
                .selectAll("text")
                .data([0, 1])
                .join("text")
                .attr("text-anchor", "middle")
                .attr("class", "extent-caption");

            this.mainG.append('g')
                .call(brush)
                .call(brush.move, this.timeExtent.map(this.scale.x));

            console.log(this.extent_captions)

            function brushHandle(g, selection) { 
                g
                    .selectAll(".handle--custom")
                    .data([{ type: "w" }, { type: "e" }])
                    .join(
                        enter => enter.append("path")
                            .attr("class", "handle--custom")
                            .attr("d", self.brushResizePath)
                    )
                    .attr("display", selection === null ? "none" : null)
                    .attr("transform", selection === null ? null : (d, i) => `translate(${selection[i]},-${(self.height) / 4})`)
            }

            function brushed() {
                const selection = d3.event.selection;
                if (selection === null) {
                    // self.circle.classed("selected", false);
                } else {
                    const sx = selection.map(self.scale.x.invert).map(t => moment(t).startOf('day').toDate());
                    // self.circle.classed("selected", d => sx[0] <= d.properties.date && d.properties.date <= sx[1] ? true : false);
                    self
                        .extent_captions
                        .attr("x", i => selection[i])
                        .text(i => day_date_format(sx[i]))


                    self.$emit("time_extent_changed", sx)
                }

                brushHandle(d3.select(this), selection);
            }
        }
    },

    computed: {

        timeExtent() {
            return d3.extent(this.points, s => s.properties.date);
        },

        scale() {
            const x = d3.scaleTime(this.timeExtent, [0, this.width]);
            const y = d3.randomNormal(this.height / 2, this.height / 10);
            window.x = x;
            return {x, y};
        },

        width() {
            return this.svgWidth - this.margin.left - this.margin.right;
        },

        height() {
            return this.svgHeight - this.margin.top - this.margin.bottom;
        }
    },
}
</script>


<style lang="scss">

.timebrush {
    margin: 0;
    
    svg {
        display: block;
    }

    .handle--custom {
        stroke: #000;
        stroke-width: 1;
        cursor: ew-resize;
    }
    
    circle {
        &.success {fill: var(--col-win)}
        &.fail {fill: var(--col-fail)}
        fill-opacity: 0.3;

        &.selected {
            fill-opacity: 0.8;
        }
    }

    .selection {
        fill: var(--col-highlight-bg);
        fill-opacity: 0.5;
        stroke: none;
    }

    .extent-caption {
        fill: #777;
    }
}
</style>